import { TitleCasePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'parseUnderscore',
    standalone: true,
})
export class ParseUnderscoreStringPipe implements PipeTransform {
    public transform(underscoreValue: string | null | undefined): string {
        if (!underscoreValue) {
            return 'N/A';
        }

        const titleCasePipe = new TitleCasePipe();
        const withoutUnderscore = underscoreValue.replaceAll('_', ' ');

        return titleCasePipe.transform(withoutUnderscore);
    }
}
